/**
 * Created by hp on 2017/6/8.
 */
const defaults = {
    coverImage: {
        height: Math.min(480, document.body.clientWidth) * 0.57,
        image: '',
        url: ''
    },
    detailTitle: {
        has_discount: false,
        has_popular: false,
        money: '',
        type: '',
        title: '',
        subTitle: '',
        leftSide: '',
        rightSide: '',
        tagClass: '',
    },
    imgTipsDialog: {
        title: '温馨提示',
        showTipsDialog: false,
        img: '',
        msg: '',
        callback: null,
    },
    wkTab: {
        selectId: 1,
        list: []
    }
};

export default (state = defaults, action) => {
    switch (action.type) {
        case 'COMPONENT_INIT_COVER_IMAGE':
            return {...state, coverImage: action.payload};
        case 'COMPONENT_INIT_DETAIL_TITLE':
            return {...state, detailTitle: action.payload};
        case 'COMPONENT_INIT_IMGTIPS_DIALOG':
            return {...state, imgTipsDialog: action.payload};
        case 'COMPONENT_INIT_WKTAB':
            return {...state, wkTab: action.payload};
        case 'COMPONENT_SELECT_TAB':
            let tabId = parseInt(action.payload, 10);
            let tabList = state.wkTab.list.map((item) => {
                item.selected = item.id === tabId;
                return item;
            });
            state.wkTab.list = tabList;
            state.wkTab.selectId = tabId;
            return {...state, ...state.wkTab};
        case 'COMPONENT_UNMOUNT_WKTAB':
            return {...state, wkTab: {selectId: 1, list: []}};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/component.js